module.exports = __webpack_public_path__ + "media/images/svg/instagram-26ef6f0cb5e779168d6c560b82165a86.svg";